import React, { useMemo } from 'react';
import paths from 'routes/paths';
import { useBeneficiaryContext } from 'context/beneficiaryContext';
import { useAuthContext } from 'context/authContext';
import NavBar from 'components/common/profile/sideNavBar';
import {
  permissionsKeyMap,
  userActions
} from 'routes/permissions/permissionKeys';

const BeneficiaryNav = () => {
  const { beneficiary } = useBeneficiaryContext();
  const { ability } = useAuthContext();

  // Check if user has permission to view donors
  const canViewDonors = ability.can(
    userActions.read,
    permissionsKeyMap.donor.children.donors
  );

  const navLinks = useMemo(() => {
    const links = [
      { id: 1, title: 'Overview', link: paths.beneficiaryProfile },
      { id: 2, title: 'School', link: paths.beneficiaryShool },
      { id: 3, title: 'Madrasah', link: paths.beneficiaryMosque },
      { id: 4, title: 'Orphanage', link: paths.beneficiaryOrphanage },
      { id: 5, title: 'Hospital', link: paths.beneficiaryHospital },
      {
        id: 7,
        title: 'Gallery',
        link: paths.beneficiaryGallery
      },
      {
        id: 8,
        title: 'Notes',
        link: paths.beneficiaryNotes
      },
      {
        id: 9,
        title: 'Supporting Docs',
        link: paths.beneficiarySupportingDocs
      },
      {
        id: 10,
        title: 'Case Studies',
        link: paths.beneficiaryCaseStudies
      }
    ];

    // Only add Donors link if user has permission
    if (canViewDonors) {
      links.splice(5, 0, {
        id: 6,
        title: 'Donors',
        link: paths.beneficiaryDonors
      });
    }

    return links;
  }, [canViewDonors]);

  return (
    <NavBar
      navLinks={navLinks}
      user={beneficiary}
      score={false}
      type={'Beneficiary'}
    />
  );
};

export default BeneficiaryNav;
